import React from 'react';

const badgeClass = (isDark, active, clickable) =>
    `inline-flex h-[16px] min-w-[22px] items-center justify-center rounded px-1 text-[9px] font-semibold leading-none tracking-tight ${
        active
            ? isDark
                ? 'bg-emerald-500/30 text-emerald-200'
                : 'bg-emerald-100 text-emerald-800'
            : isDark
              ? 'bg-white/12 text-white/85'
              : 'bg-black/[0.06] text-black/55'
    } ${clickable ? 'cursor-pointer transition hover:opacity-90' : ''}`;

function normalizeItems(values) {
    if (!Array.isArray(values)) return [];
    return values
        .map((item) => {
            if (item == null) return null;
            if (typeof item === 'string' || typeof item === 'number') {
                const label = String(item).trim();
                if (!label) return null;
                return { value: label, label };
            }
            if (typeof item === 'object') {
                const value = String(item.value ?? item.ratio ?? item.id ?? '').trim();
                const label = String(item.label ?? item.name ?? value).trim();
                if (!value && !label) return null;
                return { value: value || label, label: label || value };
            }
            return null;
        })
        .filter(Boolean);
}

/** Компактные бейджи параметров модели (resolution / aspect_ratio), с переносом */
export function ModelParamBadges({
    values,
    isDark = false,
    title,
    className = '',
    selected = null,
    onSelect,
}) {
    const list = normalizeItems(values);
    if (!list.length) return null;
    const clickable = typeof onSelect === 'function';

    return (
        <span
            className={`inline-flex max-w-full flex-wrap items-center gap-0.5 ${className}`}
            title={clickable ? undefined : title || list.map((i) => i.label).join(', ')}
        >
            {list.map((item) => {
                const active = selected != null && selected === item.value;
                return (
                    <span
                        key={item.value}
                        role={clickable ? 'button' : undefined}
                        tabIndex={clickable ? 0 : undefined}
                        className={badgeClass(isDark, active, clickable)}
                        title={
                            item.value !== item.label
                                ? item.value
                                : clickable
                                  ? active
                                      ? 'Сбросить фильтр'
                                      : `Фильтр: ${item.label}`
                                  : undefined
                        }
                        onMouseDown={
                            clickable
                                ? (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                  }
                                : undefined
                        }
                        onClick={
                            clickable
                                ? (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onSelect(active ? null : item.value);
                                  }
                                : undefined
                        }
                        onKeyDown={
                            clickable
                                ? (e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                          e.preventDefault();
                                          onSelect(active ? null : item.value);
                                      }
                                  }
                                : undefined
                        }
                    >
                        {item.label}
                    </span>
                );
            })}
        </span>
    );
}

export default ModelParamBadges;
